import { useEffect } from 'react';

export const SITE_URL = 'https://jkrealty.ec';

const find = (selector) => document.head.querySelector(selector);

// Cambia un atributo de una etiqueta del <head> y devuelve cómo deshacerlo.
const setAttr = (selector, attr, value) => {
  const el = find(selector);
  if (!el || value == null) return () => {};
  const prev = el.getAttribute(attr);
  el.setAttribute(attr, value);
  return () => el.setAttribute(attr, prev);
};

// Pone título, descripción, canonical, Open Graph y JSON-LD propios de la página.
// El HTML prerenderizado conserva estos valores; al salir de la página se restauran.
export function useSeo({ title, description, path, image, imageAlt, jsonLd }) {
  const ld = jsonLd ? JSON.stringify(jsonLd) : null;

  useEffect(() => {
    const url = SITE_URL + path;
    const prevTitle = document.title;
    document.title = title;

    const undo = [
      setAttr('meta[name="description"]', 'content', description),
      setAttr('link[rel="canonical"]', 'href', url),
      setAttr('meta[property="og:title"]', 'content', title),
      setAttr('meta[property="og:description"]', 'content', description),
      setAttr('meta[property="og:url"]', 'content', url),
      setAttr('meta[name="twitter:title"]', 'content', title),
      setAttr('meta[name="twitter:description"]', 'content', description),
    ];

    if (image) {
      undo.push(
        setAttr('meta[property="og:image"]', 'content', SITE_URL + image),
        setAttr('meta[property="og:image:width"]', 'content', '1200'),
        setAttr('meta[property="og:image:height"]', 'content', '630'),
        setAttr('meta[property="og:image:alt"]', 'content', imageAlt || title),
        setAttr('meta[name="twitter:image"]', 'content', SITE_URL + image)
      );
    }

    let script = null;
    if (ld) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-page-ld', 'true');
      script.text = ld;
      document.head.appendChild(script);
    }

    return () => {
      document.title = prevTitle;
      undo.forEach((fn) => fn());
      if (script) script.remove();
    };
  }, [title, description, path, image, imageAlt, ld]);
}
